import React, { useState, useRef, useEffect } from "react";
import { Card } from "primereact/card";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputMask } from "primereact/inputmask";
import { Password } from "primereact/password";
import { Checkbox } from "primereact/checkbox";
import { Messages } from "primereact/messages";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { ListBox } from "primereact/listbox";
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Menu } from "primereact/menu";
import { OverlayPanel } from "primereact/overlaypanel";
import { Calendar } from "primereact/calendar";


export default function InputPeriodo({ inicio: propInicio, fim: propFim, onChangePeriodo }) {
    const [inicio, setInicio] = useState(propInicio || null);
    const [fim, setFim] = useState(propFim || null);

    const [inicioPersonalizado, setInicioPersonalizado] = useState()
    const [fimPersonalizado, setFimPersonalizado] = useState()
    

    const menuLeft = useRef(null);
    const overlayPeriodoPersonalizado = useRef(null);
    const buttonPeriodo = useRef(null);

    // Sincronizar com as props quando mudarem (receber do componente pai)
    useEffect(() => {
        if (propInicio) setInicio(propInicio);
        if (propFim) setFim(propFim);
    }, [propInicio, propFim]);

    // Chamar callback quando houver mudanças no período
    useEffect(() => {
        if (onChangePeriodo) {
            onChangePeriodo({ inicio, fim });
        }
    }, [inicio, fim, onChangePeriodo]);

    const items = [
        {
            label: 'Hoje',
            command: () => { setInicio(new Date()); setFim(new Date()); }
        },
        {
            label: 'Esta Semana',
            command: () => { setEstaSemana(); }
        },
        {
            label: 'Este Mês',
            command: () => { setEsteMes(); }
        },
        {
            label: 'Este Ano',
            command: () => { setEsteAno(); }
        },
        {
            label: 'Ultimos 30 dias',
            command: () => { setUltimos30Dias(); }
        },
        {
            label: 'Ultimos 12 meses',
            command: () => { setUltimos12Meses(); }
        },
        {
            label: 'Todo o Período',
            command: () => { setTodoPeriodo(); }
        },
        {
            label: 'Periodo Personalizado',
            command: () => { overlayPeriodoPersonalizado.current.show({ currentTarget: buttonPeriodo.current }); }
        },


    ]

    const setEstaSemana = () => {
        const hoje = new Date();
        const primeiroDiaSemana = new Date(hoje.setDate(hoje.getDate() - hoje.getDay() + 1));
        const ultimoDiaSemana = new Date(hoje.setDate(primeiroDiaSemana.getDate() + 6));
        setInicio(primeiroDiaSemana);
        setFim(ultimoDiaSemana);
    }

    const setEsteMes = () => {
        const hoje = new Date();
        const primeiroDiaMes = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
        const ultimoDiaMes = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);
        setInicio(primeiroDiaMes);
        setFim(ultimoDiaMes);
    }

    const setEsteAno = () => {
        const hoje = new Date();
        const primeiroDiaAno = new Date(hoje.getFullYear(), 0, 1);
        const ultimoDiaAno = new Date(hoje.getFullYear(), 11, 31);
        setInicio(primeiroDiaAno);
        setFim(ultimoDiaAno);
    }

    const setUltimos30Dias = () => {
        const hoje = new Date();
        const trintaDiasAtras = new Date(hoje.setDate(hoje.getDate() - 30));
        setInicio(trintaDiasAtras);
        setFim(new Date());
    }

    const setUltimos12Meses = () => {
        const hoje = new Date();
        const dozeMesesAtras = new Date(hoje.setFullYear(hoje.getFullYear() - 1));
        setInicio(dozeMesesAtras);
        setFim(new Date());
    }

    const setTodoPeriodo = () => {
        setInicio(null);
        setFim(null);
    }

    const setPeriodoPersonalizado = () => {
        if (!inicioPersonalizado || !fimPersonalizado){
            alert("Informe o período completo.")
            return
        }
        setInicio(inicioPersonalizado);
        setFim(fimPersonalizado);
        overlayPeriodoPersonalizado.current.hide()

    }

    const periodoAnterior = () => {
        const diffTime = Math.abs(fim - inicio);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        const newInicio = new Date(inicio.setDate(inicio.getDate() - (diffDays + 1)));
        const newFim = new Date(fim.setDate(fim.getDate() - (diffDays + 1)));
        setInicio(newInicio);
        setFim(newFim);
    }

    const proximoPeriodo = () => {
        const diffTime = Math.abs(fim - inicio);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        const newInicio = new Date(inicio.setDate(inicio.getDate() + (diffDays + 1)));
        const newFim = new Date(fim.setDate(fim.getDate() + (diffDays + 1)));
        setInicio(newInicio);
        setFim(newFim);
    }

    return (
        <div className="app-input-periodo">
            <button onClick= {() => periodoAnterior()} className="button-prev">
                <span className="pi pi-chevron-left"/>
            </button>
            <button onClick={(event) => menuLeft.current.toggle(event)} className="button-periodo" ref={buttonPeriodo}>
                {inicio && fim ? `${inicio.toLocaleDateString()} até ${fim.toLocaleDateString()}` : "Todo o período"} <span className="pi pi-chevron-down" style={{ fontSize: "10px" }} />
            </button>
            <button onClick= {() => proximoPeriodo()} className="button-next">
                <span className="pi pi-chevron-right" />
            </button>
            <Menu model={items} popup ref={menuLeft} id="popup_menu_left" className="app-input-periodo-menu" appendTo={this}/>
            <OverlayPanel ref={overlayPeriodoPersonalizado} appendTo={this}>
                <div style={{padding: "8px"}}>
                    <Calendar
                        value={inicioPersonalizado}
                        placeholder="Início"
                        locale="pt-BR"
                        onChange={(e) => setInicioPersonalizado(e.value)}
                        appendTo={typeof window !== 'undefined' ? document.body : null}
                    />
                    {" até "}
                    <Calendar
                        value={fimPersonalizado}
                        placeholder="Fim"
                        locale="pt-BR"
                        onChange={(e) => setFimPersonalizado(e.value)}
                        appendTo={typeof window !== 'undefined' ? document.body : null}
                    />
                    <div style={{paddingTop: "10px", marginTop: "10px", borderTop: "1px solid var(--app-border-color)"}}>
                        <Button label="Cancelar" icon="pi pi-times" className="button-cancel" onClick={() => overlayPeriodoPersonalizado.current.hide()}/>
                        <Button label="Confirmar" icon="pi pi-check" className="button-confirm" style={{float: "right"}} onClick={() => setPeriodoPersonalizado()}/>
                    </div>
                </div>
            </OverlayPanel>
        </div>
    );
}
